var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntlHotelActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 49,
    viewBox: "0 0 47 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4673 0.917969C23.1558 0.917969 23.8442 0.917969 24.5327 0.917969C30.9298 1.30036 36.3265 3.84723 40.7234 8.55859C44.5805 12.8758 46.6727 17.9696 47 23.8398C47 24.7462 47 25.6523 47 26.5586C46.6702 31.5653 44.9605 36.003 41.8708 39.8711C38.397 44.1135 34.0174 46.9066 28.7324 48.25C27.2412 48.6077 25.7341 48.8303 24.2114 48.918C23.6301 48.918 23.0486 48.918 22.4673 48.918C16.0703 48.5355 10.6734 45.9888 6.27661 41.2773C2.41949 36.9602 0.327283 31.8663 0 25.9961C0 25.2852 0 24.5741 0 23.8633C0.374421 17.3302 2.86824 11.8185 7.48145 7.32812C11.7156 3.38402 16.7108 1.24731 22.4673 0.917969Z",
    fill: "#ffffff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3698_30391)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4744 7.02344L15.5797 9.1287H31.3691L33.4744 7.02344H13.4744ZM11.3691 29.1287V42.8129H36.6323V29.1287H11.3691ZM13.4744 14.3919H34.527V23.8655H13.4744V14.3919Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4211 14.3921L7.15789 9.12891H39.7895L34.5263 14.3921H12.4211ZM16.6316 15.4447H20.8421V18.6205H16.6316V15.4447ZM20.8421 22.7952H16.6316V19.6605H20.8421V22.7952ZM21.8947 15.4447H26.1053V18.6205H21.8947V15.4447ZM26.1053 22.7952H21.8947V19.6605H26.1053V22.7952ZM27.1579 15.4447H31.3684V18.6205H27.1579V15.4447ZM31.3684 22.7952H27.1579V19.6605H31.3684V22.7952ZM37.6842 30.1815H10.3158L4 23.8657H44L37.6842 30.1815ZM29.2632 35.4447H28.2105V42.8131H19.7895V35.4447H18.7368V32.2868H29.2632V35.4447Z",
    fill: "#003263"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3698_30391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(4 4.91797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntlHotelActive);
export default __webpack_public_path__ + "static/media/intl-hotel-active.b67e48c2d13d84df85962891247d355a.svg";
export { ForwardRef as ReactComponent };